import moment from 'moment'

export function formatDate(inputDate: Date | string | undefined, dateOnly: boolean = false): string {
  if (inputDate === undefined) {
    return '-'
  } else {
    const date = new Date(inputDate + 'T00:00:00')
    const month = date.getMonth() + 1 // Months are 0-based in JavaScript Date
    const day = date.getDate()
    const year = date.getFullYear()
    return dateOnly
      ? `${month}/${day}/${year}`
      : new Date(inputDate.toString()).toLocaleString('en-US', {
          timeZone: 'UTC',
          month: 'numeric',
          day: 'numeric',
          year: 'numeric'
        })
  }
}

export function formatDateMoment(date?: string): string | undefined {
  if (!date) {
    return
  }

  return moment(`${moment(date).format('MM/DD/YYYY')} 00:00:00`).format('M/D/yyyy')
}
